module.exports = __webpack_public_path__ + "static/img/ic_switch_on@2x.616548a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_switch_on@2x.png
// module id = kezw
// module chunks = 1